import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { postStopApi } from '../../../../services/StopApi/StopApi';
import { CommonDropDownStyle } from '../../../ui/styled';
import InputDropdown from '../../../common/Forms/InputDropdown';
import {
  AUTHORIZATION_MAKE_ADJUSTMENT,
  formDateFormat,
  dateFormat2,
} from '../../../../constants';

const MakeAdjustmentDialog = (props) => {
  const { open, setOpen, setAuthOpen, setCancelPopUp, cbpList, fetchAuthList,
          authId, oldDayQty, sapOrgId, cntId, authToken} = props;
  const [startDate, setStartDate] = useState(null);
  const [days, setDays] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cbp, setCBP] = useState(null);
  const [discharge, setDischarge] = useState(null);
  const [dischargeDate, setDischargeDate] = useState(null);

  const newEpisodeReferenceData = useSelector(
    (state) => state.newEpisodeReferenceData
  );
  
  //console.log('### newEpisodeReferenceData')
  //console.log(newEpisodeReferenceData)

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (discharge && dischargeDate && startDate && endDate && cbp && days) {
      const payload = {
        authId: authId,
        oldDayQty: oldDayQty,
        dchReasonId: discharge,
        dchDate: moment(dischargeDate).format(formDateFormat),
        sapOrgId: sapOrgId,
        newCboId: cbp,
        newAdmitDate: moment(startDate).format(formDateFormat),
        newDayQty: days,
        cntId: cntId
      }
      console.log(payload);

      const authorization = authToken;
      const url = `${AUTHORIZATION_MAKE_ADJUSTMENT}`;
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setOpen(false);
          setAuthOpen(false);
          fetchAuthList();
        }
      }).catch((e) => alert(e));

    }  
  };

  const calcDays = () => {
    if (startDate && days) {
      setEndDate(moment(startDate).add(days, 'd').format(dateFormat2))
    }
    else {
      setEndDate('');
    }  
  }

  useEffect(() => {
    calcDays()
  }, [startDate, days] )


  return (
    <Dialog  open={open}>
      <DialogTitle>
        <Typography variant="h4">
          Make Adjustment
        </Typography>  
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" pb={1}>
              Discharge Original Auth
            </Typography>
          </Grid>  
          <Grid item xs={4}>
            <TextField
              id="dischargeDate"
              label="Discharge Date"
              value={dischargeDate}
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                setDischargeDate(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <CommonDropDownStyle>
              <InputLabel id="county">Discharge Reason</InputLabel>
              <Select
                labelId="discharge"
                id="discharge"
                fullWidth
                value={discharge}
                onChange={(event) => {
                  setDischarge(event.target.value);
                }}
              >
              {
                newEpisodeReferenceData?.epdDischargeReason?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.value}
                    </MenuItem>
                  )                  
                })
              }  
              </Select>
            </CommonDropDownStyle>  
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" pb={1}>
              New Auth
            </Typography>
          </Grid>  
          <Grid item xs={12}>
            <CommonDropDownStyle>
              <InputLabel id="county">New CBP</InputLabel>
              <Select
                labelId="cbp"
                id="cbp"
                fullWidth
                value={cbp}
                onChange={(event) => {
                  setCBP(event.target.value);
                }}
              >
              {
                cbpList?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.value} | {item.id}
                    </MenuItem>
                  )                  
                })
              }  
              </Select>
            </CommonDropDownStyle>  
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="startDate"
              label="New Start/Admit Date"
              value={startDate}
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                setStartDate(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="days"
              fullWidth
              type="number"
              label="Day Qty"
              value={days}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                calcDays(event.target.value)
                setDays(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="endDate"
              label="End Date"
              fullWidth
              value={endDate}
              //type="date"
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />            
          </Grid>
        </Grid>    
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCancel}>
          Cancel
        </Button>
        <Button 
          variant='contained' 
          onClick={handleSubmit}
          disabled = {!discharge || !dischargeDate || !startDate || !endDate || !cbp}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MakeAdjustmentDialog;
